/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FeedbackDtos } from './feedbackDtos';


export interface FeedbackReportDto { 
    feedbackDtoList?: Array<FeedbackDtos>;
    feedbackDtoListCount: number;
    filteredCount: number;
}
